import { ArrowLeftIcon, ArrowRightIcon } from "@innoscripta/icons";
import { useTranslation } from "react-i18next";

import { MONTHS } from "./calendar.constants";
import { CalendarViews } from "./calendar.enums";
import calendarStyles from "./styles/calendar.module.scss";
import monthSelectorStyles from "./styles/month-selector.module.scss";

type Props = {
  year: number;
  setYear: React.Dispatch<React.SetStateAction<number>>;
  setCurrentView: React.Dispatch<React.SetStateAction<CalendarViews>>;
  setMonth: React.Dispatch<React.SetStateAction<number>>;
};

export function MonthSelector({ year, setYear, setCurrentView, setMonth }: Props) {
  const { t } = useTranslation();

  const goToPreviousYear = () => {
    setYear(year - 1);
  };

  const goToNextYear = () => {
    setYear(year + 1);
  };

  return (
    <>
      <div className={calendarStyles.yearSelector}>
        <div
          className={calendarStyles.monthButton}
          onClick={goToPreviousYear}
          onKeyDown={(key) => {
            if (key.key === "Enter")
              goToPreviousYear();
          }}
          role="button"
          tabIndex={0}
        >
          <ArrowLeftIcon />
        </div>
        <div className={calendarStyles.buttons}>
          <button type="button" onClick={() => setCurrentView(CalendarViews.Weeks)}>
            {year}
          </button>
        </div>
        <div
          className={calendarStyles.monthButton}
          onClick={goToNextYear}
          onKeyDown={(key) => {
            if (key.key === "Enter")
              goToNextYear();
          }}
          role="button"
          tabIndex={0}
        >
          <ArrowRightIcon />
        </div>
      </div>
      <div className={monthSelectorStyles.months}>
        {MONTHS.map((month, i) => (
          <button
            key={month}
            type="button"
            onClick={() => {
              setMonth(i);
              setCurrentView(CalendarViews.Weeks);
            }}
          >
            {t(`months.${month}`)}
          </button>
        ))}
      </div>
    </>
  );
}
